import * as z from 'zod';
export const StoredFavoriteSchema = z.object({
    participantId: z.uuidv7(),
    active: z.boolean(),
});
//# sourceMappingURL=favorite.js.map